import { InspectionField } from '../../services/inspectionsApi';

/**
 * Räknar ut avvikelser medan användaren fyller i, med samma regler som servern
 * (InspectionService.evaluateAnswers). Servern räknar om vid sparning, så det här
 * är bara för att visa rätt sak direkt i formuläret.
 */

export interface LiveEvaluation {
    deviationKeys: string[];
    missing: string[];
}

const isEmpty = (v: any) => v === undefined || v === null || v === '' || (typeof v === 'number' && Number.isNaN(v));

const daysBetween = (from: string, to: string) => {
    const a = Date.UTC(+from.slice(0, 4), +from.slice(5, 7) - 1, +from.slice(8, 10));
    const b = Date.UTC(+to.slice(0, 4), +to.slice(5, 7) - 1, +to.slice(8, 10));
    return Math.round((b - a) / 86_400_000);
};

/** Kan fältet över huvud taget ge en avvikelse med sina nuvarande regler? */
export const canDeviate = (f: InspectionField): boolean => {
    switch (f.type) {
        case 'checkbox': return f.deviation !== false;
        case 'select': return (f.deviationValues ?? []).length > 0;
        case 'date': return f.maxAgeDays != null;
        case 'number': return f.min != null || f.max != null;
        default: return false;
    }
};

export const evaluateLive = (fields: InspectionField[], answers: Record<string, any>): LiveEvaluation => {
    const today = new Date().toLocaleDateString('sv-SE');
    const deviationKeys: string[] = [];
    const missing: string[] = [];
    for (const f of fields) {
        if (f.type === 'heading') continue;
        const v = answers[f.key];
        switch (f.type) {
            case 'checkbox': {
                const on = v === true || v === 1 || v === 'true' || v === '1';
                if (f.deviation !== false && on !== (f.expected !== false)) deviationKeys.push(f.key);
                break;
            }
            case 'select':
                if (isEmpty(v)) { if (f.required) missing.push(f.label); break; }
                if ((f.deviationValues ?? []).includes(String(v))) deviationKeys.push(f.key);
                break;
            case 'date':
                if (isEmpty(v)) { if (f.required) missing.push(f.label); break; }
                if (f.maxAgeDays != null && /^\d{4}-\d{2}-\d{2}$/.test(String(v)) && daysBetween(String(v), today) > f.maxAgeDays) deviationKeys.push(f.key);
                break;
            case 'number': {
                if (isEmpty(v)) { if (f.required) missing.push(f.label); break; }
                const n = Number(String(v).replace(',', '.'));
                if (!Number.isFinite(n)) break;
                if ((f.min != null && n < f.min) || (f.max != null && n > f.max)) deviationKeys.push(f.key);
                break;
            }
            default:
                if (isEmpty(v) && f.required) missing.push(f.label);
        }
    }
    return { deviationKeys, missing };
};
